import { Center, Text } from "@mantine/core";
import { Environment } from "../../api";
import { useConfigs } from "../../hooks/useConfigs";

export const ENVIRONMENT_BANNER_HEIGHT = 28;

// Returns the current environment if it is a non-production environment, otherwise undefined.
export function useNonProdEnvironment(): Environment | undefined {
    const configs = useConfigs();
    return configs.environment !== undefined && configs.environment !== Environment.Production ? configs.environment : undefined;
}

function getBannerColor(environment: Environment): string {
    switch (environment) {
        case Environment.Sandbox:
            return "var(--mantine-color-green-8)";
        case Environment.Dev:
            return "var(--mantine-color-orange-8)";
        default:
            return "var(--mantine-color-gray-7)";
    }
}

function getBannerLabel(environment: Environment): string {
    switch (environment) {
        case Environment.Sandbox:
            return "Sandbox";
        case Environment.Dev:
            return "Dev";
        default:
            return environment;
    }
}

export function EnvironmentBanner(props: { environment: Environment }) {
    return (
        <Center h="100%" style={{ backgroundColor: getBannerColor(props.environment) }}>
            <Text c="white" fw={700} size="sm" tt="uppercase" style={{ letterSpacing: "0.05em" }}>
                {getBannerLabel(props.environment)} environment
            </Text>
        </Center>
    );
}
